import {
    Alert,
    Button,
    Modal,
    TextField,
    Typography
} from "@mui/material";
import {useEffect, useState} from "react";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {TimeManager} from "../../timemanager";
import useToken from "../../useToken";

export default function InviteMenu(props) {
    const {
        open,
        onClose,
        mobile
    } = props;

    const [ token ] = useToken();

    const [email, setEmail] = useState('');
    const [alert, setAlert] = useState(null);

    const sendInvite = () => {
        TimeManager.account.sendInvite(token, email)
            .then(setAlert)
            .catch(setAlert);
    };

    useEffect(() => {
        setAlert(null);
        setEmail('');
    }, [open, setAlert]);

    return (
        <>
            <Modal
               open={open}
               onClose={onClose}
            >
                <div>
                    <OverlayScrollbarsComponent
                        options={{
                            scrollbars: {
                                theme: 'os-theme-light'
                            }
                        }}
                        style={{
                            padding: '4rem',
                            position: 'absolute',
                            top: mobile ? '0' : '50%',
                            left: mobile ? '0' : '50%',
                            transform: !mobile && 'translate(-50%, -50%)',
                            width: mobile ? '100vw' : '700px',
                            maxHeight: mobile ? '100vh' : 'calc(100% - 100px)',
                            height: mobile && '100vh',
                            bgcolor: 'background.paper',
                            boxShadow: '24rem',
                            borderRadius: '5px',
                            overflowY: 'hidden',
                            background: 'rgb(18, 18, 18)',
                        }}
                    >
                        <Typography
                            variant="h1"
                            component="h1"
                            mb="30px"
                            fontSize="18pt"
                            fontWeight="400"
                        >
                            Invite New User
                        </Typography>

                        {alert && (
                            <Alert severity={alert.error ? 'error' : 'success'} sx={{ mb: '30px' }}>
                                {alert.message || alert.success}
                            </Alert>
                        )}

                        <TextField
                            label="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{
                                mb: '20px',
                            }}
                            fullWidth
                        />

                        {!alert?.success && (
                            <Button
                                variant="contained"
                                sx={{
                                    mr: '10px',
                                    mt: '30px',
                                }}
                                onClick={sendInvite}
                            >
                                Send Invite
                            </Button>
                        )}

                        <Button
                            onClick={onClose}
                            sx={{
                                mt: '30px',
                            }}
                        >
                            Close
                        </Button>
                    </OverlayScrollbarsComponent>
                </div>
            </Modal>
        </>
    );
}